import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/POST_OBSERVATION';

export const {action: edit} = createAction(`${domain}/EDIT`, (observation, passive, onSuccess) => ({
    observation,
    passive,
    onSuccess,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
